import { createAxiosClient } from "@ntg/component-library/utilities";
import { useQuery } from "@tanstack/react-query";
import { IReadVerbPayload } from "../../declarations/IReadVerbPayload";

export interface ILineExistenceInfo {
    inventoryLotId: string;
    itemNumber: string;
    existsInCS: boolean;
    existsInD365: boolean;
}

const getSalesOrderLineExistence = async (
    payload: IReadVerbPayload,
): Promise<ILineExistenceInfo[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.post<ILineExistenceInfo[]>(
        `/SalesOrderLine/SalesOrderLineExistenceD365`,
        payload,
    );
    return response.data;
};

export const useGetSalesOrderLineExistence = (payload: IReadVerbPayload) => {
    const dataAreaId = payload.keys.dataAreaId as string;
    const salesOrderNumber = payload.keys.salesOrderNumber as string;
    const orderID = payload.keys.orderID as number;

    return useQuery<ILineExistenceInfo[]>({
        queryKey: [
            "GetSalesOrderLineExistenceD365",
            {
                orderID: orderID ?? null,
                dataAreaId: dataAreaId ?? null,
                salesOrderNumber: salesOrderNumber ?? null,
            },
        ],
        queryFn: () => {
            if (!orderID || orderID <= 0 || !dataAreaId || !salesOrderNumber) {
                throw new Error(
                    "Invalid params for GetSalesOrderLineExistenceD365",
                );
            }
            return getSalesOrderLineExistence(payload);
        },
        enabled:
            Boolean(
                !orderID || orderID <= 0 || !dataAreaId || !salesOrderNumber,
            ) === false,
        refetchOnWindowFocus: false,
        retry: false,
    });
};
